import React from "react"

import BlogTemplateBanner from "../BlogTemplateBanner"

import ContentfulLongText from "../ContentfulLongText"
import { BlogShareIcons } from "../BlogInteractionWidget"

import "./index.css"

const HeroWithGradient = ({ post, postCategories, postCategoryTitles, formattedDate, socialsList }) => {
    return (
        <div className="variant-gradient">
            <BlogTemplateBanner variant={post.blogTemplate} post={post} postCategories={postCategories} postCategoryTitles={postCategoryTitles} formattedDate={formattedDate} />
            <div className="blog-content">
                <div className="container-custom">
                    <div className={`relative grid col-2-6-2 col-1-md gap-10 gap-15-md richtext-content`}>
                        <BlogShareIcons socialsList={socialsList} post={post} />
                        <div>
                            {post.introTextStyling !== null && <ContentfulLongText longTextContent={post.introTextStyling.content.content} classNameProp='text-center' styleVal={{ fontSize: `${post.introTextStyling.fontSize}px`, lineHeight: `${post.introTextStyling.lineHeight}px` }} />}
                            <span className="intro-underline"></span>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeroWithGradient